import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { DnsRecordsSearchingForm, useGetAllDnsRecordsQuery } from '@/modules/DnsRecords';

import { DnsRecordsListView } from './DnsRecordsListView';

export const DnsRecordsListContainer: FC = memo(() => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: dnsRecordsListData,
    error: dnsRecordsListError,
    isLoading: isDnsRecordsListLoading,
    isFetching: isDnsRecordsListFetching,
    isError: isDnsRecordsListError
  } = useGetAllDnsRecordsQuery({ page: currentPage }, search)();

  return (
    <FallbackedLayout
      isLoading={ isDnsRecordsListLoading }
      error={ dnsRecordsListError }
      isError={ isDnsRecordsListError }
      data={ dnsRecordsListData }
    >
      { (dnsRecordsList): ReactElement => (
        <>
          <DnsRecordsSearchingForm search={ search } handleSubmitSearch={ setSearch }/>
          <DnsRecordsListView
            currentPage={ currentPage }
            dnsRecordsListItems={ dnsRecordsList.items }
            dnsRecordsListTotalItems={ dnsRecordsList.meta.totalItems }
            dnsRecordsListItemsPerPage={ dnsRecordsList.meta.itemsPerPage }
            isLoading={ isDnsRecordsListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
